{
  document.querySelectorAll('.tile .rich-text').forEach(el => {
    const children = [...el.children];
    
    // walk backwards to find the start of the trailing button group
    let firstButtonIdx = -1;
    for (let i = children.length - 1; i >= 0; i--) {
      const child = children[i];
      if (child.matches('a.button') || child.querySelector('a.button')) {
        firstButtonIdx = i;
      } else {
        break;
      }
    }

    if (firstButtonIdx !== -1) {
      children[firstButtonIdx].classList.add('push-to-bottom');
      children[firstButtonIdx - 1]?.classList.add('push-to-bottom-prev');
      // mark all trailing buttons for flex purposes
      for (let i = firstButtonIdx; i < children.length; i++) {
        children[i].classList.add('is-trailing-button');
      }
    }
  });
}